<ng-container [ngSwitch]="page">
    <div *ngIf="error !== null" class="err --active" style="bottom: 90px">
        <p class="err__descr">{{ error }}</p>
        <button class="err__cloce reset" (click)="hideError()">
            <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.0492 9.44691L18.1713 16.569C18.5956 16.9933 18.5956 17.6631 18.1713 18.0649C17.7471 18.4891 17.0773 18.4891 16.6755 18.0649L9.55336 10.9428L2.43124 18.0649C2.007 18.4891 1.3372 18.4891 0.935369 18.0649C0.511127 17.6407 0.511127 16.9709 0.935369 16.569L8.05749 9.44691L0.935369 2.32479C0.511127 1.90055 0.511127 1.23076 0.935369 0.828923C1.35961 0.404682 2.0294 0.404682 2.43124 0.828923L9.55336 7.95104L16.6755 0.828923C17.0997 0.404682 17.7695 0.404682 18.1713 0.828923C18.5956 1.25316 18.5956 1.92296 18.1713 2.32479L11.0492 9.44691Z"
                    fill="#ffffff"
                ></path>
            </svg>
        </button>
    </div>

    <div
        class="loader"
        *ngIf="loadingTalonInfo || cancelingTalon || loadingPay || isRecording"
    >
        <div class="loader__animation">
            <loader type="page"> </loader>
        </div>
        <div class="loader__text">
            <ng-container *ngIf="loadingTalonInfo">
                Загружаем информацию...
            </ng-container>
            <ng-container *ngIf="cancelingTalon">
                Отменяем посещение...
            </ng-container>
            <ng-container *ngIf="isRecording">
                Записываем на номерок...
            </ng-container>
            <ng-container *ngIf="loadingPay">
                Загружаем платеж...
            </ng-container>
        </div>
    </div>

    <ng-template
        ngSwitchCase="talon"
        *ngIf="
            (talon && talon.beginDate) ||
            (params && params.info && params.info.beginDate)
        "
    >
        <div class="pay-err staps filters record">
            <div class="record-filter">
                <div class="record-filter__wrapper">
                    <div class="record__header record-top">
                        <div class="record-top__left">
                            <div class="record-top__title record-title">
                                {{
                                    !recToPay && !params?.paramCansel
                                        ? 'Запись к врачу'
                                        : 'Вы записаны на прием'
                                }}
                            </div>
                        </div>
                        <button
                            class="record-top__cloce list-cloce reset"
                            (click)="closeExit()"
                        >
                            <img
                                src="./assets/icons/actions/close.svg"
                                alt="Закрыть"
                            />
                        </button>
                    </div>
                    <div
                        class="record__body"
                        *ngIf="
                            getInfoErrorMessage.length === 0;
                            else showInfoError
                        "
                    >
                        <div class="record__top">
                            <div class="record__doctor doctor">
                                <div class="doctor__item-img">
                                    <img
                                        [src]="getImgSrcDoc(talon?.doctorId)"
                                        class="doctor__image"
                                        (error)="errorHandlerIMG($event, 'doc')"
                                        alt="Доктор {{ getFIODoc(talon) }}"
                                    />
                                </div>
                                <div class="doctor__info">
                                    <div class="doctor__name">
                                        {{ getFullName(talon) }}
                                        <span class="doctor__spec">
                                            {{ talon?.spec }}
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        class="doctor__info-button"
                                        (click)="openDocInfoModal($event)"
                                        *ngIf="hasDoctorInfo"
                                    >
                                        <img
                                            src="./assets/icons/actions/information.svg"
                                            alt="info"
                                        />
                                    </button>
                                </div>
                            </div>
                            <div class="record__date date-info">
                                <div class="date-info__rezult">
                                    {{
                                        getTalonDateTime(
                                            talon?.beginDate ||
                                                params?.info?.beginDate,
                                            withTime()
                                        )
                                    }}
                                </div>
                                <div class="date-info__day">
                                    {{
                                        getNameDay(
                                            talon?.beginDate ||
                                                params?.info?.beginDate
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                        <button
                            class="requares__buttons"
                            *ngIf="params?.form_result_id"
                            (click)="onVisitProtocolClick($event)"
                            [class.anketa-ready]="params?.is_exist"
                        >
                            <img
                                src="./assets/icons/appointments/questionnaire.svg"
                                alt="anketa"
                                class="requares__buttons-img"
                                [class.anketa-ready]="params?.is_exist"
                            />
                            {{
                                params?.is_exist
                                    ? 'Анкета заполнена'
                                    : 'Заполните анкету'
                            }}
                        </button>

                        <div class="record__address pay-err__addres addres">
                            <div
                                class="addres__label"
                                *ngIf="!recToPay || !params?.paramCansel"
                            >
                                Пациент :
                            </div>
                            <div
                                class="addres__location"
                                *ngIf="!recToPay || !params?.paramCansel"
                            >
                                {{ patientName }}
                            </div>
                            <div class="addres__label" *ngIf="talon?.addr">
                                Прием врача по адресу:
                            </div>
                            <div class="addres__location">
                                <div
                                    class="addres__location"
                                    *ngIf="talon?.addr"
                                >
                                    {{ talon?.addr }}
                                </div>
                            </div>

                            <div class="addres__label" *ngIf="talon?.phone">
                                Телефон:
                            </div>
                            <a
                                *ngIf="talon?.phone"
                                [href]="'tel:' + talon?.phone"
                                class="addres__phone"
                                >{{ talon?.phone }}</a
                            >
                        </div>

                        <div class="record__result staps__box">
                            <div
                                class="record__payments staps__rezult filter-rezult"
                            >
                                <div
                                    class="record__service-name filter-rezult__name"
                                >
                                    <div class="service-name_block">
                                        <ng-template
                                            *ngIf="
                                                talon?.urlTelemed;
                                                then showIconTelemed;
                                                else showIconNotPayTelemed
                                            "
                                        ></ng-template>
                                        <div class="record__service-text">
                                            <div
                                                [ngClass]="{
                                                    telemed__srv:
                                                        talon?.isTelemed,
                                                }"
                                            >
                                                {{
                                                    params?.srv_text ??
                                                        params?.srv?.text ??
                                                        ''
                                                }}
                                            </div>
                                        </div>
                                        <div class="price_block">
                                            <div
                                                class="record__price filter-rezult__price"
                                            >
                                                <ng-container
                                                    *ngIf="setSumm() as sum"
                                                >
                                                    {{
                                                        sum
                                                            | priceSpace
                                                                : '1.2-2'
                                                    }}
                                                    рублей
                                                </ng-container>
                                            </div>
                                            <span
                                                class="filter-rezult__image"
                                                *ngIf="showRubSvg()"
                                                ><img
                                                    src="./assets/icons/payments/ruble.svg"
                                                    aria-hidden="true"
                                                    alt="rub"
                                            /></span>
                                        </div>
                                        <div
                                            class="pay-err__bottom bottom-apply"
                                        >
                                            <button
                                                (click)="goToPay()"
                                                class="bottom-pay__btn use"
                                                [class.nessOnlPay]="
                                                    params?.srv
                                                        ?.isCreatePayOrder === 1
                                                "
                                                [class.notNessOnlPay]="
                                                    !(
                                                        params?.srv
                                                            ?.isCreatePayOrder ===
                                                        1
                                                    )
                                                "
                                                *ngIf="
                                                    (params?.srv
                                                        ?.isCreatePayOrder ===
                                                        1 &&
                                                        params?.srv
                                                            ?.paymentStatus &&
                                                        params?.srv
                                                            ?.paymentStatus !==
                                                            3) ||
                                                    (payable &&
                                                        (!params?.paramCansel ||
                                                            params?.srv
                                                                ?.paymentStatus ===
                                                                1 ||
                                                            params?.srv
                                                                ?.paymentStatus ===
                                                                2))
                                                "
                                            >
                                                <span *ngIf="isRecording">
                                                    <mat-icon
                                                        class="file__loader"
                                                        svgIcon="loading"
                                                        style="margin-left: 0"
                                                    ></mat-icon
                                                ></span>
                                                <span *ngIf="!isRecording"
                                                    >Оплатить</span
                                                >
                                            </button>
                                            <button
                                                class="bottom-pay__btn paid"
                                                *ngIf="
                                                    params?.paramCansel &&
                                                    params?.srv
                                                        ?.paymentStatus === 3
                                                "
                                            >
                                                <span *ngIf="!isRecording"
                                                    >Оплачено</span
                                                >
                                            </button>
                                        </div>
                                    </div>
                                    <span class="record__service-desc">
                                        {{
                                            params?.srv_description ??
                                                params?.srv?.srvDescription ??
                                                params?.srv?.description ??
                                                ''
                                        }}
                                    </span>
                                </div>
                            </div>
                            <div
                                *ngIf="
                                    params?.srv?.isOnlinePay &&
                                    params?.srv?.isCreatePayOrder &&
                                    (f_appoitment || params?.paramCansel) &&
                                    params?.srv?.paymentStatus !== 3
                                "
                                class="pay-err__info"
                            >
                                Просьба оплатить в течение
                                {{ WEB_LK_PAY_LIFETIME }} минут, иначе запись
                                будет отменена
                            </div>
                        </div>

                        <barcode
                            *ngIf="talon?.visitId"
                            class="record__barcode"
                            value="{{ talon?.visitId }}"
                        ></barcode>
                    </div>
                    <ng-template #showInfoError>
                        <div class="get-info-error">
                            {{ getInfoErrorMessage }}
                        </div>
                    </ng-template>
                </div>

                <div
                    class="droparea"
                    *ngIf="params?.withUploadFiles"
                    (drop)="onDrop($event)"
                    (dragover)="onDragOver($event)"
                >
                    <label
                        class="droparea__label"
                        for="dropareaInput"
                        (click)="stopPropagation($event)"
                    >
                        <input
                            type="file"
                            [accept]="allowedExt"
                            multiple
                            id="dropareaInput"
                            class="droparea__input"
                            style="display: none"
                            (change)="onChangeInputUpload($event)"
                        />
                        <div
                            class="droparea__placeholder placeholder"
                            *ngIf="attachedFiles.size === 0"
                        >
                            <h5 class="placeholder__title">
                                Добавьте архив в формате .zip .rar или .iso
                            </h5>
                            <span class="placeholder__tip tip--desktop"
                                >или перетащите в область (объем не более 1
                                ГБ)</span
                            >
                            <span class="placeholder__tip tip--mobile"
                                >нажмите на область и выберите файл (объем не
                                более 1 ГБ)</span
                            >
                            <br />
                            <br />
                            <span class="placeholder__text">
                                Для МРТ, КТ и ПЭТ загрузите архив с DICOM<br />
                                Для Видео-ЭЭГ данные мониторинга и программу для
                                просмотра этих данных
                            </span>
                        </div>

                        <ul
                            class="filelist droparea__filelist"
                            *ngIf="attachedFiles.size"
                        >
                            <li
                                *ngFor="let file of attachedFiles | keyvalue"
                                class="file droparea__file"
                                (click)="stopPropagation($event)"
                            >
                                <span class="file__ext">{{
                                    file.value.ext
                                }}</span>
                                <span class="file__name">{{
                                    file.value.name
                                }}</span>

                                <mat-icon
                                    class="file__loader"
                                    svgIcon="loading"
                                    *ngIf="file.value.status === 0"
                                ></mat-icon>

                                <mat-icon
                                    class="file__delete"
                                    *ngIf="file.value.status !== 0"
                                    (click)="
                                        deleteFileHandler(
                                            $event,
                                            file.key,
                                            file.value.id!
                                        )
                                    "
                                    svgIcon="remove"
                                ></mat-icon>
                            </li>
                            <label
                                class="droparea__trigger"
                                for="dropareaInput"
                                *ngIf="attachedFiles.size"
                            >
                                <mat-icon svgIcon="add"></mat-icon>
                            </label>
                        </ul>
                    </label>
                </div>
                <div 
                    class="warn-sign-docs"
                    *ngIf="params?.srv?.paymentStatus !== 3 && params?.srv?.isOnlinePay"
                >
                    Данная запись является предварительным бронированием. Оформление договора и сметы на услуги происходит на бумаге в клинике. Пожалуйста, придите на прием за 15 минут до начала с паспортом для подписания документов
                </div>

                <div
                    class="pay-err__bottom bottom-apply"
                    *ngIf="!recToPay && params?.paramCansel == false"
                >
                    <button
                        [disabled]="
                            getInfoErrorMessage.length > 0 || isRecording
                        "
                        class="bottom-apply__btn use reset"
                        (click)="onRecord()"
                    >
                        <span *ngIf="!isRecording">Записаться</span>
                        <span *ngIf="isRecording">
                            <mat-icon
                                class="file__loader"
                                svgIcon="loading"
                                style="margin-left: 0"
                            ></mat-icon
                        ></span>
                    </button>
                </div>

                <div
                    class="pay-err__bottom bottom-apply"
                    *ngIf="!recToPay && params?.paramCansel == true"
                >
                    <button
                        class="bottom-apply__btn use reset"
                        (click)="onCancelPage()"
                    >
                        Отменить запись
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template ngSwitchCase="record">
        <div class="pay pay-err staps filters record">
            <div class="pay__top">
                <div class="pay-current__complite padtop complite">
                    <span class="pay__top-text"> Вы записаны на прием </span>
                    <button
                        class="record-top__cloce list-cloce reset"
                        (click)="closeExit()"
                    >
                        <img src="./assets/icons/actions/close.svg" alt="Закрыть" />
                    </button>
                </div>
                <div class="record__top">
                    <div class="record__doctor doctor">
                        <img
                            [src]="getImgSrcDoc(talon?.doctorId)"
                            class="doctor__image"
                            (error)="errorHandlerIMG($event, 'doc')"
                            alt="Доктор {{ getFIODoc(talon) }}"
                        />

                        <div class="doctor__info">
                            <div class="doctor__name">
                                {{ getFullName(talon) }}

                                <span class="doctor__spec">
                                    {{ talon?.spec }}
                                </span>
                            </div>
                            <button
                                type="button"
                                class="doctor__info-button"
                                (click)="openDocInfoModal($event)"
                            >
                                <img
                                    src="./assets/icons/actions/information.svg"
                                    alt="info"
                                />
                            </button>
                        </div>
                    </div>
                    <div class="record__date date-info">
                        <div class="date-info__rezult">
                            {{
                                getTalonDateTime(
                                    talon?.beginDate || params?.info?.beginDate,
                                    withTime()
                                )
                            }}
                        </div>
                        <div class="date-info__day">
                            {{
                                getNameDay(
                                    talon?.beginDate || params?.info?.beginDate
                                )
                            }}
                        </div>
                    </div>
                </div>
                <button
                    class="requares__buttons"
                    *ngIf="params?.form_result_id"
                    (click)="onVisitProtocolClick($event)"
                    [class.anketa-ready]="params?.is_exist"
                >
                    <img
                        src="./assets/icons/appointments/questionnaire.svg"
                        alt="anketa"
                        class="requares__buttons-img"
                        [class.anketa-ready]="params?.is_exist"
                    />
                    {{
                        params?.is_exist
                            ? 'Анкета заполнена'
                            : 'Заполните анкету'
                    }}
                </button>
                <div class="record__address pay-err__addres addres">
                    <div class="addres__label" *ngIf="talon?.addr">
                        Прием врача по адресу:
                    </div>
                    <div class="addres__location" *ngIf="talon?.addr">
                        {{ talon?.addr }}
                    </div>
                    <div class="addres__label" *ngIf="talon?.phone">
                        Телефон:
                    </div>
                    <a [href]="'tel:' + talon?.phone" class="addres__phone">{{
                        talon?.phone
                    }}</a>
                </div>
            </div>
            <div class="record__result staps__box">
                <div class="record__payments staps__rezult filter-rezult">
                    <div class="record__service-name filter-rezult__name">
                        <div class="service-name_block">
                            <ng-template
                                *ngIf="
                                    talon?.urlTelemed;
                                    then showIconTelemed;
                                    else showIconNotPayTelemed
                                "
                            ></ng-template>
                            <div class="record__service-text">
                                <div
                                    [ngClass]="{
                                        telemed__srv: talon?.isTelemed,
                                    }"
                                >
                                    {{
                                        params?.srv_text ??
                                            params?.srv?.text ??
                                            ''
                                    }}
                                </div>
                            </div>
                            <div class="price_block">
                                <div class="record__price filter-rezult__price">
                                    <ng-container *ngIf="setSumm() as sum">
                                        {{ sum | priceSpace: '1.2-2' }} рублей
                                    </ng-container>
                                </div>
                                <span
                                    class="filter-rezult__image"
                                    *ngIf="showRubSvg()"
                                    ><img
                                        src="./assets/icons/payments/ruble.svg"
                                        aria-hidden="true"
                                        alt="rub"
                                /></span>
                            </div>
                        </div>
                        <span class="record__service-desc">
                            {{
                                params?.srv_description ??
                                    params?.srv?.srvDescription ??
                                    params?.srv?.description ??
                                    ''
                            }}
                        </span>
                    </div>
                </div>
            </div>
            <div
                class="droparea"
                *ngIf="params?.withUploadFiles"
                (drop)="onDrop($event)"
                (dragover)="onDragOver($event)"
            >
                <label
                    class="droparea__label"
                    for="dropareaInput"
                    (click)="stopPropagation($event)"
                >
                    <input
                        type="file"
                        [accept]="allowedExt"
                        multiple
                        id="dropareaInput"
                        class="droparea__input"
                        style="display: none"
                        (change)="onChangeInputUpload($event)"
                    />
                    <div
                        class="droparea__placeholder placeholder"
                        *ngIf="attachedFiles.size === 0"
                    >
                        <h5 class="placeholder__title">
                            Добавьте архив в формате .zip .rar или .iso
                        </h5>
                        <span class="placeholder__tip tip--desktop"
                            >или перетащите в область (объем не более 1
                            ГБ)</span
                        >
                        <span class="placeholder__tip tip--mobile"
                            >нажмите на область и выберите файл (объем не более
                            1 ГБ)</span
                        >
                        <br />
                        <br />
                        <span class="placeholder__text">
                            Для МРТ, КТ и ПЭТ загрузите архив с DICOM<br />
                            Для Видео-ЭЭГ данные мониторинга и программу для
                            просмотра этих данных
                        </span>
                    </div>

                    <ul
                        class="filelist droparea__filelist"
                        *ngIf="attachedFiles.size"
                    >
                        <li
                            *ngFor="let file of attachedFiles | keyvalue"
                            class="file droparea__file"
                            (click)="stopPropagation($event)"
                        >
                            <span class="file__ext">{{ file.value.ext }}</span>
                            <span class="file__name">{{
                                file.value.name
                            }}</span>

                            <mat-icon
                                class="file__loader"
                                svgIcon="loading"
                                *ngIf="file.value.status === 0"
                            ></mat-icon>

                            <mat-icon
                                class="file__delete"
                                *ngIf="file.value.status !== 0"
                                (click)="
                                    deleteFileHandler(
                                        $event,
                                        file.key,
                                        file.value.id!
                                    )
                                "
                                svgIcon="remove"
                            ></mat-icon>
                        </li>
                        <label
                            class="droparea__trigger"
                            for="dropareaInput"
                            *ngIf="attachedFiles.size"
                        >
                            <mat-icon svgIcon="add"></mat-icon>
                        </label>
                    </ul>
                </label>
            </div>
            <div 
                class="warn-sign-docs"
                *ngIf="params?.srv?.paymentStatus !== 3 && params?.srv?.isOnlinePay"
            >
                Данная запись является предварительным бронированием. Оформление договора и сметы на услуги происходит на бумаге в клинике. Пожалуйста, придите на прием за 15 минут до начала с паспортом для подписания документов
            </div>

            <div class="pay-err__bottom pay__box">
                <div class="pay-current__buttons bottom-apply">
                    <button
                        class="bottom-apply__btn lose reset"
                        (click)="toHistory($event)"
                    >
                        Мои номерки
                    </button>
                    <button
                        class="bottom-apply__btn use reset"
                        (click)="toRecord($event)"
                    >
                        Новая запись
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template ngSwitchCase="pay">
        <div class="pay pay-err staps record">
            <div class="pay__top record-top">
                <div class="record-top__left">
                    <div class="record-top__title record-title">
                        Онлайн-оплата
                    </div>
                </div>
                <button class="list-cloce reset">
                    <img
                        src="./assets/icons/actions/close-modal.svg"
                        alt="Закрыть"
                        [mat-dialog-close]="true"
                    />
                </button>
            </div>

            <div class="pay__center">
                <div class="pay__mail mail" *ngIf="emailRequiredForPay">
                    <input
                        id="mail"
                        class="mail__input reset"
                        placeholder="Адрес почты"
                        type="email"
                        [(ngModel)]="payParam.email"
                    />
                    <label for="mail" class="mail__label"
                        >Почта для получения чека</label
                    >
                </div>
                <div class="pay__mail mail" *ngIf="phoneRequiredForPay">
                    <input
                        id="phone"
                        class="mail__input reset"
                        placeholder="+7 (999) 999-99-99"
                        type="tel"
                        phoneMask
                        inputmode="numeric"
                        [(ngModel)]="payParam.phone"
                        autocomplete="tel"
                        aria-label="Номер телефона"
                    />
                    <label for="phone" class="mail__label"
                        >Номер телефона</label
                    >
                </div>
                <div class="pay__total total">
                    <input
                        type="hidden"
                        [(ngModel)]="payParam.sum"
                        required
                        class="cls-input-sum"
                        readonly
                    />
                    <span class="total__label">Всего к оплате</span>
                    <strong class="total__price"
                        >{{ payParam.sum | priceSpace: '1.2-2' }} рублей</strong
                    >
                </div>
            </div>

            <div class="pay__nav">
                <div class="pay__row"></div>
                <div class="pay-err__bottom bottom-apply">
                    <!-- Сообщение об ошибке ввода -->
                    <div
                        class="pay-error-message"
                        *ngIf="getPayErrorMessage()"
                        style="
                            color: #e53935;
                            font-size: 14px;
                            margin-bottom: 8px;
                            text-align: center;
                        "
                    >
                        {{ getPayErrorMessage() }}
                    </div>

                    <button
                        class="bottom-apply__btn use reset"
                        (click)="goPay()"
                        [disabled]="validPay()"
                        [title]="getPayErrorMessage() || ''"
                    >
                        <svg
                            width="25"
                            height="17"
                            viewBox="0 0 25 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M1.94424 0H21.9782C23.0772 0 24.007 0.929851 24.007 1.94424V14.1167C24.007 15.2156 23.0772 16.0609 21.9782 16.0609H1.94424C0.929851 16.0609 0 15.2156 0 14.1167V1.94424C0 0.929851 0.929851 0 1.94424 0ZM2.02877 7.43867H22.4853V9.89011H2.02877V7.43867ZM2.53597 2.02857H7.35413C7.60772 2.02857 7.86132 2.28217 7.86132 2.53577V5.49443C7.86132 5.74803 7.60772 5.91709 7.35413 5.91709H2.53597C2.28237 5.91709 2.02877 5.74802 2.02877 5.49443V2.53577C2.02877 2.28217 2.28237 2.02857 2.53597 2.02857Z"
                                fill="white"
                            />
                        </svg>
                        Оплатить
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template ngSwitchCase="cancelOK">
        <div class="cancel-window">
            <div class="cancel-window_top">
                <button class="record-back reset" (click)="closeExit()">
                    <img src="./assets/icons/navigation/back-secondary.svg" alt="Назад" />
                </button>
                <div class="record-top__title record-title">Отмена записи</div>

                <button
                    class="record-top__cloce list-cloce reset"
                    (click)="closeExit()"
                >
                    <img src="./assets/icons/actions/close.svg" alt="Закрыть" />
                </button>
            </div>

            <div class="list-item">
                <div class="list-item__box">
                    <div class="list-item__box-top">
                        <img
                            [src]="getImgSrcDoc(talon?.doctorId)"
                            (error)="errorHandlerIMG($event, 'doc')"
                            alt="Доктор {{ getFIODoc(talon) }}"
                            class="doctor__image"
                        />
                        <div class="list-item__info">
                            <span class="doctor__name">{{
                                getFIODoc(talon)
                            }}</span>
                            <span class="list-item__number">
                                {{ talon?.spec }}
                                <img
                                    src="./assets/icons/actions/information.svg"
                                    aria-hidden="true"
                                    alt="info"
                                />
                            </span>
                        </div>
                    </div>

                    <div class="record__date">
                        <div class="date-info__rezult">
                            {{ getTalonDateTime(talon?.beginDate, withTime()) }}
                        </div>
                        <div class="date-info__day">
                            {{ getNameDay(talon?.beginDate) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="staps__box">
                <div class="staps__rezult filter-rezult">
                    <div class="filter-rezult__name">
                        {{ params?.srv?.text }}
                    </div>
                    <div class="filter-rezult__price">
                        <ng-container *ngIf="setSumm() as sum">
                            {{ sum | priceSpace: '1.2-2' }} рублей
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="pay-err__bottom bottom-apply">
                <button
                    class="bottom-apply__btn lose reset"
                    routerLink="/home/history"
                    [mat-dialog-close]="true"
                >
                    Не отменять
                </button>
                <button
                    class="bottom-apply__btn use reset"
                    routerLink="/home/history"
                    (click)="onCancelRecord()"
                >
                    <span *ngIf="!isRecording"> Отменить </span>
                    <span *ngIf="isRecording">
                        <mat-icon
                            class="file__loader"
                            svgIcon="loading"
                            style="margin-left: 0"
                        ></mat-icon
                    ></span>
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template ngSwitchCase="goToTeleComp">
        <div class="loading-group">
            <div *ngIf="loadingTalon" class="loading">
                <loader type="page"> </loader>
            </div>
            <div class="popup-bg-white">
                <div
                    mat-dialog-content
                    class="talon-content container-fluid talon-m"
                >
                    <div class="cls-blok-res-rec cls-cansel-text addToTele">
                        <p class="title">
                            <b>Подключиться к Телеконференции?</b>
                        </p>

                        <div class="cls-cansel-btn">
                            <button
                                class="btn cls-btn-second cls-btn-filter cls-cansel-btn-no"
                                routerLink="/home/history"
                                [mat-dialog-close]="true"
                            >
                                Нет
                            </button>
                            <button
                                class="btn cls-btn-second cls-btn-filter cls-cansel-btn-yes cls-cansel-btn-yes--orange"
                                routerLink="/home/history"
                                (click)="goToTelemed(talon)"
                            >
                                Да
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>

<ng-template #showIconTelemed>
    <ng-template #tipContentPay let-greeting="greeting">
        Подключиться к телеконференции.
    </ng-template>
    <mat-icon
        *ngIf="talon?.isTelemed == 1"
        svgIcon="telemedicine"
        class="telemed-icon cls-icon-is-telemed icon-srv-telemed"
        (click)="goToTelemed(talon)"
        placement="top"
        [ngbTooltip]="tipContentPay"
        tooltipClass="tooltipPanel"
        container="body"
    >
    </mat-icon>
</ng-template>

<ng-template #showIconNotPayTelemed>
    <ng-template #tipContentNotPay let-greeting="greeting">
        <div style="min-width: 225px">
            Ссылка на Телеконференцию появится только после оплаты.
        </div>
    </ng-template>
    <mat-icon
        *ngIf="talon?.isTelemed == 1"
        svgIcon="telemedicine"
        class="telemed-icon ls-icon-is-telemed icon-srv-telemed"
        placement="top"
        [ngbTooltip]="tipContentNotPay"
        tooltipClass="tooltipPanelTeleNotPay"
        container="body"
    >
    </mat-icon>
</ng-template>
